<header class="header" [ngStyle]="getColor()">
 <div class="header-middle sticky-header">
  <div [ngStyle]="getMarqueeColor()">
   <ngx-fast-marquee class="--floating-center --rotate" speed="medium" [maskPercentage]="0" direction="left" [pauseOnHover]="true" [play]="true">
    <div class="item --bold --box span-class" style="font-size: 9.75pt; font-weight: 700; display: flex; align-items: center; gap: 6px" role="marquee" style="margin-top: 8px; font-size: 9.75pt; font-weight: 700" *ngFor="let text of marqueeText">
     {{ text.title }}
    </div>
   </ngx-fast-marquee>
  </div>

  <div class="container-fluid" style="background: #000" [ngStyle]="getColor()">
   <div class="laptop-menu-bar">
    <div class="row" style="width: 100%">
     <div class="col-md-4" style="margin: auto">
      <a class="logo logo-top-space" tabindex="0" routerLink="/" aria-label="Highlifehealth.co">
       <img src="{{ siteDada?.footerLogo?.url }}" alt="Highlife Health -  Cannabis Dispensary, Buy Medical Cannabis" class="laptop-logo-size" width="100" height="100" />
      </a>

      <div class="hearder-store-infi">
       <h4 style="color: #000; font-size: 15px" tabindex="0">Pickup + Delivery</h4>

       <h4 *ngIf="this.storeTime && !StoreClosed" [ngStyle]="getTextIconColor({ color: this.siteDada?.headerTextColor })" tabindex="0">
        Open Until
        {{ newStoreHoursFormat(this.storeTime?.Close?.Hour, this.storeTime?.Close?.Minute) }}
        <a href="javascript:;" (click)="modalOpen()" (keydown.enter)="modalOpen()" tabindex="0" role="button" aria-label="info modal" style="top: 1px; position: relative">
         <i class="fa fa-info-circle" [ngStyle]="getTextIconColor({ color: this.siteDada?.headerTextColor })" style="padding-left: 2px"></i>
        </a>
       </h4>
       <h4 *ngIf="this.storeTime && StoreClosed" tabindex="0" style="color: red">
        Closed
        <a href="javascript:;" style="position: relative; top: 1px" tabindex="0" role="button" aria-label="Store info popup" (click)="modalOpen()" (keydown.enter)="modalOpen()">
         <i class="fa fa-info-circle" [ngStyle]="getTextIconColor({ color: this.siteDada?.headerTextColor })"></i>
        </a>
       </h4>
       <h4 *ngIf="!this.storeTime && !StoreClosed">
        <a href="javascript:;" (click)="modalOpen()" (keydown.enter)="modalOpen()" tabindex="0" role="button" aria-label="info modal">
         <i class="fa fa-info-circle" [ngStyle]="getTextIconColor({ color: this.siteDada?.headerTextColor })"></i>
        </a>
       </h4>
      </div>
     </div>
     <div class="col-md-4" style="margin: auto">
      <div class="header-new-search-bar">
    
        <input type="text" #dynamicPlaceholder tabindex="0" name="search" placeholder="SMART SEARCH" [(ngModel)]="searchInput" autocomplete="off" [ngStyle]="getTextIconColor({ border: '2px solid ' + siteDada?.headerTextColor })" aria-label="Smart search for cannabis products" aria-describedby="searchHelp1" (keyup)="searchSuggest($event)" (keyup.enter)="searchProduct(searchInput)" />
        <div id="searchHelp1" class="sr-only">Type to search for products. Press Enter to search.</div>

        <i class="icon-search" tabindex="0" role="button" aria-label="Search button" (click)="searchProduct(searchInput)" [ngStyle]="getTextIconColor({ color: siteDada?.headerTextColor })"></i>

        <div id="DivOut" *ngIf="(searchIn || suggList) && search_suggestionArr?.length > 0" style="position: absolute; background: white; width: 100%; z-index: 9; height: auto; overflow-y: scroll">
         <span style="font-size: 12px; margin: 5px">Discover More</span>

         <ul style="list-style: none">
          <li class="searchinheader" *ngFor="let item of topSearchArray" style="display: flex; align-items: center">
           <a tabindex="0" (click)="searchProduct(item?.slug)" (keydown.enter)="searchProduct(item?.slug)">
            {{ item?.name }}
           </a>
          </li>
         </ul>

         <ul style="list-style: none">
          <li class="searchinheader" *ngFor="let pl of search_suggestionArr" style="display: flex; align-items: center">
           <img class="img_mobile_search" alt="Product image" [src]="pl?.productDetails.HeroShotUri ? pl?.productDetails.HeroShotUri : pl.productDetails.Assets[0]?.Uri ? pl.productDetails.Assets[0]?.Uri : defaultUrl" />
           <a routerLink="/shop/product/{{ pl?.productslug }}" tabindex="0" (click)="hideSearchDiv()">
            {{ pl?.productDetails?.ProductName }}
           </a>
          </li>
         </ul>
        </div>

        <div style="position: absolute; background: white; width: 100%; z-index: 9">
         <p *ngIf="!searchIn && showNoResult" tabindex="0" aria-live="polite">No Results</p>
        </div>
      </div>
     </div>
     <div class="col-md-4" style="margin: auto">
      <div class="header-right right-herader-top">
       <div class="dropdown cart-dropdown">
        <a href="javascript:;" class="dropdown-toggle cursor" tabindex="0" aria-label="User Profile" *ngIf="!auth" [routerLink]="['login']" style="margin-right: 8px">
         <i class="icon-user" [ngStyle]="getTextIconColor({ color: this.siteDada?.headerTextColor })"></i>
        </a>
        <a href="javascript:;" tabindex="0" [routerLink]="['/cart']" [attr.aria-label]="'Open Cart Product in cart' + cartLength" class="cursor dropdown-toggle">
         <i class="icon-shopping-cart" [ngStyle]="getTextIconColor({ color: this.siteDada?.headerTextColor })"></i>
         <span class="cart-count" style="position: absolute; top: -10px; right: -9px">{{ cartLength }}</span>
        </a>
       </div>
       <div style="margin-left: 15px">
        <button type="button" (click)="openNavs()" class="menu-bar menu-icon-size cursor" aria-label="Open side navigation menu">
         <i class="fa fa-bars" aria-hidden="true" [ngStyle]="getTextIconColor({ color: siteDada?.headerTextColor })"></i>
        </button>
       </div>
      </div>
      <div *ngIf="auth" class="right-head-username">
       <span style="font-size: 16px">
        <a routerLink="/dashboard/profile" [ngStyle]="getTextIconColor({ color: this.siteDada?.headerTextColor })" tabindex="0">Hi, &nbsp; {{ userName | firstword | titlecase }}</a>
       </span>
      </div>
     </div>
    </div>
   </div>
   <div class="mobile-menu-bar">
    <div class="header-left">
     <a href="/" class="logo" tabindex="0" aria-label="Highlifehealth.co">
      <img alt="Website header logo" role="presentation" src="{{ siteDada?.footerLogo?.url }}" alt="logo" width="80" height="80" />
     </a>
     <div class="hearder-store-infi">
      <h4 style="color: #000; font-size: 10px">Pickup + Delivery</h4>
      <h4 *ngIf="this.storeTime && !StoreClosed" [ngStyle]="getTextIconColor({ color: this.siteDada?.headerTextColor, 'line-height': '0.7' })">
       Open Until
       {{ newStoreHoursFormat(this.storeTime?.Close?.Hour, this.storeTime?.Close?.Minute) }}
       <a href="javascript:;" (click)="modalOpen()" (keydown.enter)="modalOpen()" tabindex="0" role="button" aria-label="info popup">
        <i class="fa fa-info-circle" [ngStyle]="getTextIconColor({ color: this.siteDada?.headerTextColor })"></i>
       </a>
      </h4>
      <h4 *ngIf="this.storeTime && StoreClosed" style="color: red">
       Closed
       <a href="javascript:;" style="position: relative; top: 1px" tabindex="0" role="button" aria-label="info popup" (click)="modalOpen()" (keydown.enter)="modalOpen()">
        <i class="fa fa-info-circle"></i>
       </a>
      </h4>
      <h4 *ngIf="!this.storeTime && !StoreClosed">
       <a href="javascript:;" (click)="modalOpen()" tabindex="0" role="button" aria-label="info popup" (keydown.enter)="modalOpen()">
        <i class="fa fa-info-circle"></i>
       </a>
      </h4>
     </div>
    </div>
    <div class="header-right">
     <div class="header-search" [ngClass]="{ mobileSearch: isSearchShow }">
      <a href="javascript:;" (click)="isSearchShow = !isSearchShow" role="button" tabindex="0" aria-label="Close Search" class="search-toggle" role="button" title="Close"><i class="icon-close"></i></a>
      <a href="javascript:;" class="mobile-search-button" role="button" tabindex="0" aria-label="Open Search"><i class="icon-search" [ngStyle]="getTextIconColor({ color: this.siteDada?.headerTextColor })" (click)="searchProduct(searchInput)"></i></a>
             <div id="search1" tabindex="0">
        <label for="search" class="sr-only">Search</label>

        <input type="text" class="form-control" name="search" id="search" placeholder="SMART SEARCH" [(ngModel)]="searchInput" (keyup)="searchSuggest($event)" (keyup.enter)="searchProduct(searchInput)" appAutocompleteOff aria-describedby="searchHelp" />

        <div id="searchHelp" class="sr-only">Type to search for products. Press Enter to search.</div>

        <div id="DivOut" *ngIf="searchIn && search_suggestionArr?.length > 0" role="listbox" aria-label="Search Suggestions" style="position: absolute; background: white; width: 100%; z-index: 9">
         <ul role="list">
          <li *ngFor="let pl of search_suggestionArr" role="option">
           <a tabindex="0" routerLink="/shop/product/{{ pl.productslug }}" (click)="hideSearchDiv()" (keydown.enter)="hideSearchDiv()">
            {{ pl.productDetails.ProductName }}
           </a>
          </li>
         </ul>
        </div>

        <p *ngIf="!searchIn && showNoResult" aria-live="polite">No Results</p>
       </div>
      <!-- </form> -->
     </div>

     <div class="dropdown cart-dropdown">
      <a href="javascript:;" class="search_head" tabindex="0" role="button" aria-label="Search" (click)="isSearchShow = !isSearchShow">
       <i class="icon-search" [ngStyle]="getTextIconColor({ color: this.siteDada?.headerTextColor })"></i>
      </a>

      <a href="javascript:;" (click)="openLogoutPopUp()" tabindex="0" role="button" aria-label="logout" *ngIf="auth" class="dropdown-toggle" style="font-size: 2.7rem; margin-right: 2px">
       <i class="fa fa-sign-out" [ngStyle]="getTextIconColor({ color: this.siteDada?.headerTextColor })"></i>
      </a>
      <a *ngIf="!auth" routerLink="/login" tabindex="0" aria-label="Sign in Account" class="dropdown-toggle cursor" style="margin-right: 2px">
       <i class="icon-user" [ngStyle]="getTextIconColor({ color: this.siteDada?.headerTextColor })"></i>
      </a>
      <a href="javascript:;" routerLink="/cart" class="dropdown-toggle cursor" tabindex="0" [attr.aria-label]="'Open Cart Product in cart' + cartLength">
       <i class="icon-shopping-cart" [ngStyle]="getTextIconColor({ color: this.siteDada?.headerTextColor })"></i>
       <span class="cart-count">{{ cartLength }}</span>
      </a>
     </div>
    </div>
    <div class="responsive-meni-bar-toggle">
     <a onclick="openNav()" class="menu-bar" (click)="openNavs()">
      <i class="fa fa-bars" tabindex="0" role="button" aria-label="Open side navigation menu" [ngStyle]="getTextIconColor({ color: this.siteDada?.headerTextColor })"></i>
     </a>
    </div>
   </div>
  </div>

  <div class="header-menu-section" [ngStyle]="getColor()">
   <div class="container">
    <div class="row for-desktop-menu">
     <div class="col-md-12">
      <nav class="new-menu-part">
       <ul class="menu sf-arrows">
        <ng-container *ngIf="categoryList">
         <li *ngIf="categoryList?.length">
          <a tabindex="0" routerLink="/shop/all" [ngStyle]="getTextIconColor({ color: siteDada?.headerTextColor, 'font-weight': 600 })">ALL</a>
         </li>

         <li *ngIf="categoryList?.length">
          <a tabindex="0" routerLink="/shop/NewArrivals" [ngStyle]="getTextIconColor({ color: siteDada?.headerTextColor, 'font-weight': 600 })">NEW</a>
         </li>

         <li *ngFor="let list of categoryList; let i = index" aria-label="Product category">
          <a role="button" tabindex="0" [class.activeCategory]="list?.slug === CategoryId" [routerLink]="['/shop', list.categoryName + '_' + list.slug]" [ngStyle]="getTextIconColor({ color: siteDada?.headerTextColor, 'font-weight': 600 })" [attr.aria-label]="'Product category ' + list?.categoryName" [attr.aria-haspopup]="list?.subCategory?.length ? 'true' : null" [attr.aria-expanded]="list?.subCategory?.length ? 'false' : null">
           {{ list?.categoryName | uppercase }}
           <i *ngIf="list?.subCategory?.length" class="fa fa-angle-down" aria-hidden="true"></i>
          </a>

          <ul *ngIf="list?.subCategory?.length">
           <li *ngFor="let subCategory of list?.subCategory">
            <a role="button" tabindex="0" [ngStyle]="getTextIconColor({ color: siteDada?.headerTextColor, 'font-weight': 600 }, 'subcat')" [attr.aria-label]="'Subcategory ' + subCategory?.subCategoryName" [routerLink]="['/shop/subProduct', list.slug + '_' + subCategory.slug]">
             {{ subCategory?.subCategoryName | uppercase }}
            </a>
           </li>
          </ul>
         </li>
        </ng-container>
       </ul>
      </nav>
     </div>
    </div>
    <div class="for-mobile-menu">
     <ul class="">
      <ng-container *ngIf="categoryList">
       <li><a *ngIf="categoryList?.length" href="javascript:void(0)" tabindex="0" routerLink="/shop/all" [ngStyle]="getTextIconColor({ color: this.siteDada?.headerTextColor, 'font-weight': 600 })">ALL</a></li>

       <li><a *ngIf="categoryList?.length" href="javascript:void(0)" tabindex="0" routerLink="/shop/NewArrivals" [ngStyle]="getTextIconColor({ color: this.siteDada?.headerTextColor, 'font-weight': 600 })">NEW</a></li>

       <li *ngFor="let item of categoryList; let i = index">
        <a href="javascript:void(0)" (click)="openSubCat(item)" tabindex="0" [ngStyle]="getTextIconColor({ color: this.siteDada?.headerTextColor, 'font-weight': 600 })">
         {{ item?.categoryName | uppercase }}
        </a>
       </li>
       <ng-container *ngIf="subCatList?.length > 0 && subCatClick == true">
        <ul class="mobile_sub_menu_list">
         <li (click)="redirectToShopPage(subCategoryMobile); subCatClick = false">
          <a href="javascript:void(0)" tabindex="0" [ngStyle]="getTextIconColor({ color: this.siteDada?.headerTextColor, 'font-weight': 600 }, 'subcatMobile')">All {{ subCategoryMobile?.categoryName | uppercase }}</a>
         </li>
         <li *ngFor="let subCategory of subCatList">
          <a href="javascript:void(0)" tabindex="0" [ngStyle]="getTextIconColor({ color: this.siteDada?.headerTextColor, 'font-weight': 600 }, 'subcatMobile')" (click)="redirectToShopPageWithSubCategoryId(subCategory, subCategoryMobile)" (keydown.enter)="redirectToShopPageWithSubCategoryId(subCategory, subCategoryMobile)">
           {{ subCategory?.subCategoryName | uppercase }}
          </a>
         </li>
        </ul>
       </ng-container>
      </ng-container>
     </ul>
    </div>
   </div>
  </div>
 </div>
</header>
<div class="hedaerHeightLaptop" [ngStyle]="getColor()"></div>
<div class="modal search-location modalBackgroundNone firstpopuponload3 where-are-you" tabindex="-1" role="dialog" aria-hidden="false" aria-modal="true" aria-label="Logout Screen" id="logoutPopUp" data-backdrop="static" data-keyboard="false">
 <div class="modal-dialog">
  <div class="modal-content" style="background: transparent !important">
   <div class="modal-body logoutPopupWidth">
    <h5 tabindex="0">Are you sure to Logout?</h5>
    <div class="location" style="padding: 0">
     <div class="row">
      <div class="col-md-6">
       <button tabindex="0" role="button" (click)="hideLogoutPopUp()" (keydown.enter)="hideLogoutPopUp()" class="popupButton" style="width: 100%">No</button>
      </div>
      <div class="col-md-6">
       <button (click)="logout()" (keydown.enter)="logout()" tabindex="0" role="button" class="popupButton" style="width: 100%; background: #000; color: #fff">Logout</button>
      </div>
     </div>
    </div>
   </div>
  </div>
 </div>
</div>

<div class="modal get-verify-number-popup mobilePopUp" tabindex="-1" role="dialog" aria-hidden="false" aria-modal="true" id="storeHistoryModal" style="background: url(assets/images/bg1.jpg); background: rgba(0, 0, 0, 0.8) !important">
 <div class="modal-dialog">
  <div class="modal-content">
   <div class="modal-body responsive_PopUp_Store_Location_Info">
    <div class="herader_location_overlay">
     <div class="herader_location_popup">
      <a *ngIf="pickUpStoreList?.length > 1" tabindex="0" (click)="selectMailOrderFromHeader('true')" (keydown.enter)="selectMailOrderFromHeader('true')" class="newButton" style="display: inline-block">Switch Location</a>
      <a (click)="storeOpenCloseTimeing(selectedStoreName)" (keydown.enter)="storeOpenCloseTimeing(selectedStoreName)" tabindex="0" aria-label="store " class="aboutIcon">
       <i class="fa fa-info-circle"></i>
      </a>
      <a class="phoneIcon" [href]="'tel:' + getStoreMObile()">
       <i class="fa fa-phone"></i>
      </a>
      <img src="{{ storeImage }}" tabindex="0" alt="Welcome to High Life Health" style="border-radius: 15px 15px 0 0; margin-bottom: 0px; width: 100%" />
      <div class="storeLocatIc">
       <div>
        <h2 tabindex="0">
         {{ selectedStoreName }}
         <span class="store_open_new" *ngIf="!StoreClosed">Open</span>
         <span class="store_close_new" *ngIf="StoreClosed">Closed</span>
        </h2>
       </div>
       <div class="loc-adddress-home">
        <i class="fa fa-map-marker"></i>

        <a target="_blank" href="http://maps.google.com/?q={{ storeDetails?.Address?.AddressLine2 }}" aria-describedby="Storeaddresslinks2">
         {{ storeDetails?.Address?.AddressLine2 }}
        </a>
       </div>
       <h4 style="display: flex; align-items: center">
        <span class="desktop-Visible" tabindex="0">Service Options</span>
       </h4>
       <p style="font-size: 16px; font-weight: 600" id="newIdgivenNow">
        {{ manageOrderOptions('Pickup') }}
        {{ manageOrderOptions('CurbsidePickup') }}

        <b style="font-size: 15px" class="stylePop" tabindex="0">
         <div *ngIf="manageStoreTIme('Pickup')" class="instoreTimgim mt-1">
          <img src="assets/images/shopping-bag.png" class="img_Po_bottom" alt="" />
          In-Store
          <span *ngIf="!storeTime?.isOpen">
           {{ newStoreHoursFormat(this.storeTime?.Open?.Hour, this.storeTime?.Open?.Minute) }} -
           {{ newStoreHoursFormat(this.storeTime?.Close?.Hour, this.storeTime?.Close?.Minute) }}
          </span>
          <span *ngIf="storeTime?.isOpen" style="color: red; background: none">Closed</span>
         </div>
         <div *ngIf="manageStoreTIme('Delivery')" class="instoreTimgim m-0">
          <img src="assets/images/delivering.png" class="img_Po_bottom" alt="" />
          Delivery
          <span *ngIf="!dilverytime?.isOpen">
           {{ newStoreHoursFormat(this.dilverytime?.Open?.Hour, this.dilverytime?.Open?.Minute) }} -
           {{ newStoreHoursFormat(this.dilverytime?.Close?.Hour, this.dilverytime?.Close?.Minute) }}
          </span>
          <span *ngIf="dilverytime?.isOpen" style="color: red; background: none">Closed</span>
         </div>
        </b>
       </p>
       <a class="herader_location_popup_close" (click)="modalClose()" (keydown.enter)="modalClose()" tabindex="0" role="button" aria-label="Close modal"><i class="fa fa-close"></i></a>
      </div>
     </div>
    </div>
   </div>
  </div>
 </div>
</div>

<div class="modal mobilePopUp" id="storeOpenCloseTimeing2" abindex="-1" role="dialog" aria-modal="true" style="z-index: 99999 !important">
 <div class="modal-dialog new-Height" style="height: 100%">
  <div class="modal-content new-Height" style="height: 100%; margin: 10px">
   <div class="modal-body">
    <p *ngIf="showLoading">Loading ...</p>
    <div class="herader_location_overlay" *ngIf="!showLoading">
     <h2 tabindex="0">STORE HOURS</h2>
     <div class="week-days">
      <input *ngIf="manageOrderOption('Pickup')" tabindex="0" (click)="getCalled('tab1')" (keydown.enter)="getCalled('tab1')" id="tab1" type="radio" name="tabs" checked />
      <label *ngIf="manageOrderOption('Pickup')" for="tab1" tabindex="0" (click)="getCalled('tab1')" (keydown.enter)="getCalled('tab1')">Pickup</label>
      <input *ngIf="manageOrderOption('CurbsidePickup')" id="tab3" (click)="getCalled('tab3')" (keydown.enter)="getCalled('tab3')" tabindex="0" type="radio" name="tabs" />
      <label *ngIf="manageOrderOption('CurbsidePickup')" for="tab3" tabindex="0" (click)="getCalled('tab3')" (keydown.enter)="getCalled('tab3')">Curbside</label>
      <input *ngIf="manageOrderOption('Delivery')" id="tab2" tabindex="0" (click)="getCalled('tab2')" (keydown.enter)="getCalled('tab2')" type="radio" name="tabs" />
      <label *ngIf="manageOrderOption('Delivery')" for="tab2" tabindex="0" (click)="getCalled('tab2')" (keydown.enter)="getCalled('tab2')">Delivery</label>
      <div *ngIf="manageOrderOption('Pickup')" class="content" id="content1" tabindex="0">
       <div class="row">
        <div class="col-4" tabindex="0"><span>Sunday:</span></div>

        <div class="col-8" *ngIf="!CurrentStoreData?.StoreHours?.Sunday?.isOpen">
         <span>
          <span class="slide_menu_hour" tabindex="0">{{ newStoreHoursFormat(CurrentStoreData?.StoreHours?.Sunday?.Open?.Hour, CurrentStoreData?.StoreHours?.Sunday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span class="slide_menu_min" tabindex="0">{{ newStoreHoursFormat(CurrentStoreData?.StoreHours?.Sunday?.Close?.Hour, CurrentStoreData?.StoreHours?.Sunday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.StoreHours?.Sunday?.isOpen">Closed</div>
       </div>

       <div class="row">
        <div class="col-4" tabindex="0"><span>Monday:</span></div>
        <div class="col-8" *ngIf="!CurrentStoreData?.StoreHours?.Monday?.isOpen">
         <span>
          <span tabindex="0" class="slide_menu_hour">{{ newStoreHoursFormat(CurrentStoreData?.StoreHours?.Monday?.Open?.Hour, CurrentStoreData?.StoreHours?.Monday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span tabindex="0" class="slide_menu_min">{{ newStoreHoursFormat(CurrentStoreData?.StoreHours?.Monday?.Close?.Hour, CurrentStoreData?.StoreHours?.Monday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div tabindex="0" class="col-8 closed-houres" *ngIf="CurrentStoreData?.StoreHours?.Monday?.isOpen">Closed</div>
       </div>
       <div class="row">
        <div tabindex="0" class="col-4"><span>Tuesday:</span></div>

        <div class="col-8" *ngIf="!CurrentStoreData?.StoreHours?.Tuesday?.isOpen">
         <span>
          <span tabindex="0" class="slide_menu_hour">{{ newStoreHoursFormat(CurrentStoreData?.StoreHours?.Tuesday?.Open?.Hour, CurrentStoreData?.StoreHours?.Tuesday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span tabindex="0" class="slide_menu_min">{{ newStoreHoursFormat(CurrentStoreData?.StoreHours?.Tuesday?.Close?.Hour, CurrentStoreData?.StoreHours?.Tuesday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div tabindex="0" class="col-8 closed-houres" *ngIf="CurrentStoreData?.StoreHours?.Tuesday?.isOpen">Closed</div>
       </div>
       <div class="row">
        <div class="col-4" tabindex="0"><span>Wednesday:</span></div>

        <div class="col-8" *ngIf="!CurrentStoreData?.StoreHours?.Wednesday?.isOpen">
         <span>
          <span tabindex="0" class="slide_menu_hour">{{ newStoreHoursFormat(CurrentStoreData?.StoreHours?.Wednesday?.Open?.Hour, CurrentStoreData?.StoreHours?.Wednesday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span tabindex="0" class="slide_menu_min">{{ newStoreHoursFormat(CurrentStoreData?.StoreHours?.Wednesday?.Close?.Hour, CurrentStoreData?.StoreHours?.Wednesday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div tabindex="0" class="col-8 closed-houres" *ngIf="CurrentStoreData?.StoreHours?.Wednesday?.isOpen">Closed</div>
       </div>
       <div class="row">
        <div tabindex="0" class="col-4"><span>Thursday:</span></div>

        <div class="col-8" *ngIf="!CurrentStoreData?.StoreHours?.Thursday?.isOpen">
         <span>
          <span tabindex="0" class="slide_menu_hour">{{ newStoreHoursFormat(CurrentStoreData?.StoreHours?.Thursday?.Open?.Hour, CurrentStoreData?.StoreHours?.Thursday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span tabindex="0" class="slide_menu_min">{{ newStoreHoursFormat(CurrentStoreData?.StoreHours?.Thursday?.Close?.Hour, CurrentStoreData?.StoreHours?.Thursday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div tabindex="0" class="col-8 closed-houres" *ngIf="CurrentStoreData?.StoreHours?.Thursday?.isOpen">Closed</div>
       </div>
       <div class="row">
        <div class="col-4" tabindex="0"><span>Friday:</span></div>

        <div class="col-8" *ngIf="!CurrentStoreData?.StoreHours?.Friday?.isOpen">
         <span>
          <span tabindex="0" class="slide_menu_hour">{{ newStoreHoursFormat(CurrentStoreData?.StoreHours?.Friday?.Open?.Hour, CurrentStoreData?.StoreHours?.Friday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span tabindex="0" class="slide_menu_min">{{ newStoreHoursFormat(CurrentStoreData?.StoreHours?.Friday?.Close?.Hour, CurrentStoreData?.StoreHours?.Friday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div tabindex="0" class="col-8 closed-houres" *ngIf="CurrentStoreData?.StoreHours?.Friday?.isOpen">Closed</div>
       </div>
       <div class="row">
        <div class="col-4" tabindex="0"><span>Saturday:</span></div>

        <div class="col-8" *ngIf="!CurrentStoreData?.StoreHours?.Saturday?.isOpen">
         <span>
          <span tabindex="0" class="slide_menu_hour">{{ newStoreHoursFormat(CurrentStoreData?.StoreHours?.Saturday?.Open?.Hour, CurrentStoreData?.StoreHours?.Saturday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span tabindex="0" class="slide_menu_min">{{ newStoreHoursFormat(CurrentStoreData?.StoreHours?.Saturday?.Close?.Hour, CurrentStoreData?.StoreHours?.Saturday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div tabindex="0" class="col-8 closed-houres" *ngIf="CurrentStoreData?.StoreHours?.Saturday?.isOpen">Closed</div>
       </div>
       <div class="row">
        <div class="col-12">
         <div class="box">
          <img src="{{ storeImage }}" alt="Welcome to High Life Health" style="border-radius: 0px; margin-bottom: 15px; width: 100%" />

          <div style="display: flex; padding: 5px">
           <h3 tabindex="0" style="font-size: 16px">
            You're shopping at
            <strong>
             {{ selectedStoreName }}
            </strong>
           </h3>
           <div class="newForthis">
            <span tabindex="0" class="store_open" *ngIf="!StoreClosed">Open</span>
            <span tabindex="0" class="store_close" *ngIf="StoreClosed">Closed</span>
           </div>
          </div>
          <p class="loc-adddress-home" style="padding: 5px">
           <img src="assets/images/place.png" width="24px" class="loca-img-new" alt="Location details icon" />
           <a style="font-size: 13px" href="http://maps.google.com/?q={{ storeAddresss }}" target="_blank" tabindex="0" aria-describedby="Storeaddresslinks4">
            {{ storeAddresss }}
           </a>
           <span id="Storeaddresslinks4" style="display: none" tabindex="0">This is the address for our store, which you can open in Google Maps.</span>
          </p>
         </div>
        </div>
       </div>
      </div>
      <div *ngIf="manageOrderOption('CurbsidePickup')" class="content" id="content3" tabindex="0">
       <div class="row">
        <div class="col-4" tabindex="0"><span>Sunday:</span></div>
        <div class="col-8" *ngIf="!CurrentStoreData?.CurbsideHours?.Sunday?.isOpen">
         <span>
          <span class="slide_menu_hour" tabindex="0">{{ newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Sunday?.Open?.Hour, CurrentStoreData?.CurbsideHours?.Sunday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span class="slide_menu_min" tabindex="0">{{ newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Sunday?.Close?.Hour, CurrentStoreData?.CurbsideHours?.Sunday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div class="col-8 closed-houres" tabindex="0" *ngIf="CurrentStoreData?.CurbsideHours?.Sunday?.isOpen" tabindex="0">Closed</div>
       </div>

       <div class="row">
        <div class="col-4" tabindex="0"><span>Monday:</span></div>

        <div class="col-8" *ngIf="!CurrentStoreData?.CurbsideHours?.Monday?.isOpen">
         <span>
          <span class="slide_menu_hour" tabindex="0">{{ newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Monday?.Open?.Hour, CurrentStoreData?.CurbsideHours?.Monday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span class="slide_menu_min" tabindex="0">{{ newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Monday?.Close?.Hour, CurrentStoreData?.CurbsideHours?.Monday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div class="col-8 closed-houres" tabindex="0" *ngIf="CurrentStoreData?.CurbsideHours?.Monday?.isOpen" tabindex="0">Closed</div>
       </div>
       <div class="row">
        <div class="col-4" tabindex="0"><span>Tuesday:</span></div>

        <div class="col-8" *ngIf="!CurrentStoreData?.CurbsideHours?.Tuesday?.isOpen">
         <span>
          <span class="slide_menu_hour" tabindex="0">{{ newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Tuesday?.Open?.Hour, CurrentStoreData?.CurbsideHours?.Tuesday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span class="slide_menu_min" tabindex="0">{{ newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Tuesday?.Close?.Hour, CurrentStoreData?.CurbsideHours?.Tuesday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div class="col-8 closed-houres" tabindex="0" *ngIf="CurrentStoreData?.CurbsideHours?.Tuesday?.isOpen" tabindex="0">Closed</div>
       </div>
       <div class="row">
        <div class="col-4" tabindex="0"><span>Wednesday:</span></div>

        <div class="col-8" *ngIf="!CurrentStoreData?.CurbsideHours?.Wednesday?.isOpen">
         <span>
          <span class="slide_menu_hour" tabindex="0">{{ newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Wednesday?.Open?.Hour, CurrentStoreData?.CurbsideHours?.Wednesday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span class="slide_menu_min" tabindex="0">{{ newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Wednesday?.Close?.Hour, CurrentStoreData?.CurbsideHours?.Wednesday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div class="col-8 closed-houres" tabindex="0" *ngIf="CurrentStoreData?.CurbsideHours?.Wednesday?.isOpen" tabindex="0">Closed</div>
       </div>
       <div class="row">
        <div class="col-4" tabindex="0"><span>Thursday:</span></div>

        <div class="col-8" *ngIf="!CurrentStoreData?.CurbsideHours?.Thursday?.isOpen" tabindex="0">
         <span>
          <span class="slide_menu_hour" tabindex="0">{{ newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Thursday?.Open?.Hour, CurrentStoreData?.CurbsideHours?.Thursday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span class="slide_menu_min" tabindex="0">{{ newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Thursday?.Close?.Hour, CurrentStoreData?.CurbsideHours?.Thursday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.CurbsideHours?.Thursday?.isOpen" tabindex="0">Closed</div>
       </div>
       <div class="row">
        <div class="col-4" tabindex="0"><span>Friday:</span></div>

        <div class="col-8" *ngIf="!CurrentStoreData?.CurbsideHours?.Friday?.isOpen" tabindex="0">
         <span>
          <span class="slide_menu_hour" tabindex="0">{{ newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Friday?.Open?.Hour, CurrentStoreData?.CurbsideHours?.Friday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span class="slide_menu_min" tabindex="0">{{ newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Friday?.Close?.Hour, CurrentStoreData?.CurbsideHours?.Friday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.CurbsideHours?.Friday?.isOpen" tabindex="0">Closed</div>
       </div>
       <div class="row">
        <div class="col-4" tabindex="0"><span>Saturday:</span></div>

        <div class="col-8" *ngIf="!CurrentStoreData?.CurbsideHours?.Saturday?.isOpen">
         <span>
          <span class="slide_menu_hour" tabindex="0">{{ newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Saturday?.Open?.Hour, CurrentStoreData?.CurbsideHours?.Saturday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span class="slide_menu_min" tabindex="0">{{ newStoreHoursFormat(CurrentStoreData?.CurbsideHours?.Saturday?.Close?.Hour, CurrentStoreData?.CurbsideHours?.Saturday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.CurbsideHours?.Saturday?.isOpen" tabindex="0">Closed</div>
       </div>
       <div class="row">
        <div class="col-12">
         <div class="box">
          <img src="{{ storeImage }}" alt="Welcome to High Life Health" style="border-radius: 0px; margin-bottom: 15px; width: 100%" />

          <div style="display: flex; padding: 5px">
           <h3 style="font-size: 16px" tabindex="0">
            You're shopping at
            <strong>
             {{ selectedStoreName }}
            </strong>
           </h3>
           <div class="newForthis">
            <span class="store_open" tabindex="0" *ngIf="!StoreClosed">Open</span>
            <span class="store_close" tabindex="0" *ngIf="StoreClosed">Closed</span>
           </div>
          </div>
          <p class="loc-adddress-home" style="padding: 5px">
           <img src="assets/images/place.png" width="24px" class="loca-img-new" alt="Location details icon" />

           <a style="font-size: 13px" href="http://maps.google.com/?q={{ storeAddresss }}" target="_blank" tabindex="0" aria-describedby="Storeaddresslinks3">
            {{ storeAddresss }}
           </a>
           <span id="Storeaddresslinks3" style="display: none">This is the address for our store, which you can open in Google Maps.</span>
          </p>
         </div>
        </div>
       </div>
      </div>

      <div *ngIf="manageOrderOption('Delivery')" class="content" id="content2" tabindex="0">
       <div class="row">
        <div class="col-4" tabindex="0"><span>Sunday:</span></div>
        <div class="col-8" *ngIf="!CurrentStoreData?.DeliveryHours?.Sunday?.isOpen">
         <span>
          <span class="slide_menu_hour" tabindex="0">{{ newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Sunday?.Open?.Hour, CurrentStoreData?.DeliveryHours?.Sunday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span class="slide_menu_min" tabindex="0">{{ newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Sunday?.Close?.Hour, CurrentStoreData?.DeliveryHours?.Sunday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div class="col-8 closed-houres" tabindex="0" *ngIf="CurrentStoreData?.DeliveryHours?.Sunday?.isOpen" tabindex="0">Closed</div>
       </div>
       <div class="row">
        <div class="col-4" tabindex="0"><span>Monday:</span></div>
        <div class="col-8" *ngIf="!CurrentStoreData?.DeliveryHours?.Monday?.isOpen">
         <span>
          <span class="slide_menu_hour" tabindex="0">{{ newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Monday?.Open?.Hour, CurrentStoreData?.DeliveryHours?.Monday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span class="slide_menu_min" tabindex="0">{{ newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Monday?.Close?.Hour, CurrentStoreData?.DeliveryHours?.Monday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.DeliveryHours?.Monday?.isOpen" tabindex="0">Closed</div>
       </div>
       <div class="row">
        <div class="col-4" tabindex="0"><span>Tuesday:</span></div>

        <div class="col-8" *ngIf="!CurrentStoreData?.DeliveryHours?.Tuesday?.isOpen">
         <span>
          <span tabindex="0" class="slide_menu_hour">{{ newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Tuesday?.Open?.Hour, CurrentStoreData?.DeliveryHours?.Tuesday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span tabindex="0" class="slide_menu_min">{{ newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Tuesday?.Close?.Hour, CurrentStoreData?.DeliveryHours?.Tuesday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.DeliveryHours?.Tuesday?.isOpen" tabindex="0">Closed</div>
       </div>
       <div class="row">
        <div class="col-4" tabindex="0"><span>Wednesday:</span></div>

        <div class="col-8" *ngIf="!CurrentStoreData?.DeliveryHours?.Wednesday?.isOpen">
         <span>
          <span tabindex="0" class="slide_menu_hour">{{ newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Wednesday?.Open?.Hour, CurrentStoreData?.DeliveryHours?.Wednesday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span tabindex="0" class="slide_menu_min">{{ newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Wednesday?.Close?.Hour, CurrentStoreData?.DeliveryHours?.Wednesday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.DeliveryHours?.Wednesday?.isOpen" tabindex="0">Closed</div>
       </div>
       <div class="row">
        <div class="col-4" tabindex="0"><span>Thursday:</span></div>

        <div class="col-8" *ngIf="!CurrentStoreData?.DeliveryHours?.Thursday?.isOpen">
         <span>
          <span tabindex="0" class="slide_menu_hour">{{ newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Thursday?.Open?.Hour, CurrentStoreData?.DeliveryHours?.Thursday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span tabindex="0" class="slide_menu_min">{{ newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Thursday?.Close?.Hour, CurrentStoreData?.DeliveryHours?.Thursday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.DeliveryHours?.Thursday?.isOpen" tabindex="0">Closed</div>
       </div>
       <div class="row">
        <div class="col-4" tabindex="0"><span>Friday:</span></div>

        <div class="col-8" *ngIf="!CurrentStoreData?.DeliveryHours?.Friday?.isOpen">
         <span>
          <span tabindex="0" class="slide_menu_hour">{{ newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Friday?.Open?.Hour, CurrentStoreData?.DeliveryHours?.Friday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span tabindex="0" class="slide_menu_min">{{ newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Friday?.Close?.Hour, CurrentStoreData?.DeliveryHours?.Friday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.DeliveryHours?.Friday?.isOpen" tabindex="0">Closed</div>
       </div>
       <div class="row">
        <div class="col-4" tabindex="0"><span>Saturday:</span></div>

        <div class="col-8" *ngIf="!CurrentStoreData?.DeliveryHours?.Saturday?.isOpen">
         <span>
          <span tabindex="0" class="slide_menu_hour">{{ newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Saturday?.Open?.Hour, CurrentStoreData?.DeliveryHours?.Saturday?.Open?.Minute) }}</span>
          <span class="slide_menu_dass">-</span>
          <span tabindex="0" class="slide_menu_min">{{ newStoreHoursFormat(CurrentStoreData?.DeliveryHours?.Saturday?.Close?.Hour, CurrentStoreData?.DeliveryHours?.Saturday?.Close?.Minute) }}</span>
         </span>
        </div>
        <div class="col-8 closed-houres" *ngIf="CurrentStoreData?.DeliveryHours?.Saturday?.isOpen" tabindex="0">Closed</div>
       </div>
       <div class="row">
        <div class="col-12">
         <div class="box">
          <img src="{{ storeImage }}" alt="Welcome to High Life Health" style="border-radius: 0px; margin-bottom: 15px; width: 100%" />

          <div style="display: flex; padding: 5px">
           <h3 style="font-size: 16px" tabindex="0">
            You're shopping at
            <strong>
             {{ selectedStoreName }}
            </strong>
           </h3>
           <div class="newForthis">
            <span class="store_open" *ngIf="!StoreClosed" tabindex="0">Open</span>
            <span class="store_close" *ngIf="StoreClosed" tabindex="0">Closed</span>
           </div>
          </div>
          <p class="loc-adddress-home" style="padding: 5px">
           <img src="assets/images/place.png" width="24px" class="loca-img-new" alt="Location details icon" />

           <a style="font-size: 13px" href="http://maps.google.com/?q={{ storeAddresss }}" tabindex="0" target="_blank" tabindex="0" aria-describedby="Storeaddresslink">
            {{ storeAddresss }}
           </a>
           <span id="Storeaddresslink" style="display: none" tabindex="0">This is the address for our store, which you can open in Google Maps.</span>
          </p>
         </div>
        </div>
       </div>
      </div>
     </div>
     <a class="herader_location_popup_close" (click)="closeStoreTimeModal2()"><i class="fa fa-close"></i></a>
    </div>
   </div>
  </div>
 </div>
</div>

<div class="modal fade" id="cartLimitModal" tabindex="-1" role="dialog" aria-labelledby="cartLimitModalLabel" aria-hidden="true" style="background: rgba(0, 0, 0, 0.6); z-index: 99999">
 <div class="modal-dialog" role="document" style="top: 20%">
  <div class="modal-content order_limit" [ngStyle]="getColor()">
   <div class="modal-header popup">
    <h5 class="modal-title" tabindex="0" id="cartLimitModalLabel" [ngStyle]="getTextIconColor({ color: siteDada?.headerTextColor }, 'Powered')">This item puts You,</h5>

    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
     <i class="fa fa-close" [ngStyle]="getTextIconColor({ color: siteDada?.headerTextColor }, 'Powered')"></i>
    </button>
   </div>

   <div class="modal-body">
    <h5 class="content_modal" tabindex="0" [ngStyle]="getTextIconColor({ color: siteDada?.headerTextColor }, 'Powered')">Over The {{ CartBarLimit }}g Legal Order Limit</h5>
   </div>
  </div>
 </div>
</div>

<div class="modal fade" id="cartLimitModalFlower" tabindex="-1" role="dialog" aria-labelledby="cartLimitModalFlowerLabel" aria-hidden="true" style="background: rgba(0, 0, 0, 0.6); z-index: 99999">
 <div class="modal-dialog" role="document" style="top: 20%">
  <div class="modal-content order_limit" [ngStyle]="getColor()">
   <div class="modal-header popup">
    <h5 class="modal-title" tabindex="0" id="cartLimitModalFlowerLabel">Weight Limit</h5>

    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
     <i class="fa fa-close" [ngStyle]="getTextIconColor({ color: siteDada?.headerTextColor }, 'Powered')"></i>
    </button>
   </div>

   <div class="modal-body">
    <h4 tabindex="0" [ngStyle]="getTextIconColor({ color: siteDada?.headerTextColor }, 'Powered')">This item puts You,</h4>

    <h5 class="content_modal" tabindex="0" [ngStyle]="getTextIconColor({ color: siteDada?.headerTextColor }, 'Powered')">Over The {{ CartBarLimitFlower }}g Legal Order Limit</h5>
   </div>
  </div>
 </div>
</div>

<div id="mySidenav" class="sidenav" tabindex="-1" role="dialog" aria-label="Side Navigation menu" [ngStyle]="getSideNavColor()">
 <a href="javascript:void(0)" class="closebtn" onclick="closeNav()" (click)="openNavs()" tabindex="0" aria-label="Close Side Navigation menu">
  <i class="fa fa-close"></i>
 </a>

 <div *ngIf="auth" id="username_onmob" style="display: none !important" class="right-head-username">
  <span style="top: 15px; color: aliceblue; font-size: 16px; position: absolute; left: 10px">
   Hi, &nbsp;
   <a (click)="hideSidenav_user()" tabindex="0" routerLink="/dashboard/profile" style="color: #fff">{{ userName | firstword | titlecase }}</a>
  </span>
 </div>
 <div style="padding: 10px 15px; margin-bottom: 0px; text-align: center">
  <img class="sideImg" src="{{ siteDada?.footerLogo?.url }}" width="100" alt="website logo" />
 </div>

 <ul class="sideMenu-tiles">
  <li [ngStyle]="{ background: item?.bgColor }" *ngFor="let item of sideMenu">
   <a *ngIf="item?.url != 'store' && item?.show" onclick="closeNav()" (click)="openNavs()" tabindex="0" [routerLink]="routeToUrls(item?.url, item)" routerLinkActive="active" class="cursor" [routerLinkActiveOptions]="{ exact: true }" id="isShop">
    <img *ngIf="item?.logo" src="{{ item?.logo }}" [alt]="item.title + 'logo'" />
    <span [ngStyle]="{ color: item?.textColor }">{{ item?.title }}</span>
   </a>

   <a *ngIf="item?.url == 'store' && item?.show" (click)="openMapModal()" tabindex="0" routerLinkActive="active" class="cursor" [routerLinkActiveOptions]="{ exact: true }" id="isShop">
    <img *ngIf="item?.logo" src="{{ item?.logo }}" [alt]="item.title + 'logo'" />
    <span [ngStyle]="{ color: item?.textColor }">{{ item?.title }}</span>
   </a>
  </li>
 </ul>

 <div class="right-slide-bar-bottom">
  <div class="row">
   <div class="col-12">
    <a href="javascript:;" onclick="closeNav()" [routerLink]="['/register']" *ngIf="!auth" class="signup" style="background: #fff">create account</a>
   </div>

   <!-- SIGN IN -->
   <div class="col-12">
    <a href="javascript:;" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" [routerLink]="['/login']" class="signin" onclick="closeNav()" *ngIf="!auth" style="background: #9ac07f">Sign In</a>
   </div>

   <div class="col-12">
    <a href="javascript:;" [routerLink]="['/dashboard/profile']" onclick="closeNav()" *ngIf="auth" class="signin" style="background: #fff">MY ACCOUNT</a>
   </div>
   <div class="col-12">
    <a href="javascript:;" onclick="closeNav()" (click)="openLogoutPopUp(); openNavs()" (keydown.enter)="openLogoutPopUp(); openNavs()" *ngIf="auth" class="signup" style="background: #9ac07f">log out</a>
   </div>
  </div>
 </div>
 <div>
  <a class="slide-menu-store-timing" (click)="openStoreTimeModal3()" (keydown.enter)="openStoreTimeModal3()" tabindex="0" [ngStyle]="getTextIconColor({ 'background-color': 'transparent', color: '#000' }, 'HOURS')">
   STORE HOURS
   <br />
  </a>
 </div>
</div>
<div class="modal mobilePopUp" id="storeOpenCloseTimeing" abindex="-1" role="dialog" aria-modal="true"
  style="background: url(assets/images/HUSH-indexpage.webp);  background: rgba(0, 0, 0, 0.2) !important;">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <div class="herader_location_overlay newPara_dynamic">
          <ng-container *ngFor="let list of pickUpStoreList">
            <div *ngIf="list.Name == selectedStoreName">
              <p tabindex="0" innerHtml="
                                {{ list?.storeInfo }}"></p>

              <a class="herader_location_popup_close" tabindex="0" role="button" aria-label="Close Modal"
                (click)="storeOpenCloseTimeing1()" (keydown.enter)="storeOpenCloseTimeing1()"><i
                  class="fa fa-close"></i></a>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>